import React from "react";
import Spinner from "react-bootstrap/Spinner";
import styleClasses from "../Spinner/Spinner.module.scss";

interface IBasicSpinnerProps {
  BasicSpinner?: any;
  BasicLoader?: any;
  style?:any
}
const BasicSpinner = (props: IBasicSpinnerProps) => {
  const { BasicSpinner, BasicLoader, style={} } = props;
  return (
    <div className={`${Object.keys(style)?.length > 0 ? styleClasses.spinner_wrapper_with_custom_spinner_style : styleClasses.spinner_wrapper} ${BasicSpinner}`}>
      <Spinner
        animation="border"
        role="status"
        className={`${styleClasses.spinner_loader} ${BasicLoader}`}
        style={style}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default BasicSpinner;
